export enum CostTypeEnum {
    TRAVEL = "TRAVEL",
    PERSONNEL_MANAGEMENT_ADMINISTRATION = "PERSONNEL_MANAGEMENT_ADMINISTRATION",
    MAINTENANCE_ACTIVITIES = "MAINTENANCE_ACTIVITIES",
    INVESTMENT = "INVESTMENT",
    MANAGEMENT_ADMINISTRATION = "MANAGEMENT_ADMINISTRATION",
    OTHER_SUBSIDIZABLE_EXPENSES = "OTHER_SUBSIDIZABLE_EXPENSES",
}

export class CostType {
    constructor(
        public readonly id: CostTypeEnum,
        public readonly label: string,
    ) { }
}

// Crear el enum de subtipos
export enum CostSubtypeEnum {
    NONE = "NONE",
    // Subtipos para TRAVEL
    DISPLACEMENT = "DISPLACEMENT",
    ACCOMMODATION_MEALS = "ACCOMMODATION_MEALS",
    // Otros subtipos existentes
    THIRD_PARTY_ACCOUNT = "THIRD_PARTY_ACCOUNT",
    THIRD_PARTY_SERVICES = "THIRD_PARTY_SERVICES",
    RENT = "RENT",
    UTILITIES = "UTILITIES",
    UTILITIES_CONSTRUCTION_AND_EQUIPMENT = "UTILITIES_CONSTRUCTION_AND_EQUIPMENT",
    INSURANCE = "INSURANCE",
    CONSUMABLES = "CONSUMABLES",
    MATERIALS_FOR_ACTIVITIES = "MATERIALS_FOR_ACTIVITIES",
    TRANSPORT_OF_GOODS_AND_INMOVILITIES = "TRANSPORT_OF_GOODS_AND_INMOVILITIES",
    OCCASIONAL_COLLABORATIONS = "OCASIONAL_COLLABORATIONS",
    CONFERENCES_LECTURES = "CONFERENCES_LECTURES",
    WORK_OTHER_COMPANIES = "WORK_OTHER_COMPANIES",
    VOLUNTEERING = "VOLUNTEERING",
    LIABILITY_INSURANCE = "LIABILITY_INSURANCE",
    EXPENSES_INCURRED_BENEFICIARIES = "EXPENSES_INCURRED_BENEFICIARIES",
    SOFTWARE_LICENSES = "SOFTWARE_LICENSES",
    OTHERS_MINOR_EXPENSES = "OTHERS_MINOR_EXPENSES",
    FURNITURE = "FURNITURE",
    COMPUTER_EQUIPMENT = "COMPUTER_EQUIPMENT",
    REAL_ESTATE = "REAL_ESTATE",
    OTHERS_INVESTMENT_EXPENSES = "OTHERS_INVESTMENT_EXPENSES",
    CONSULTING_SERVICES = "CONSULTING_SERVICES",
    AUDITING = "AUDITING",
    LABOR_MANAGEMENT_LICENSES = "LABOR_MANAGEMENT_LICENSES",
    QUALITY = "QUALITY",
    PERSONNEL = "PERSONNEL",
}

export class CostSubtype {
    constructor(
        public readonly id: CostSubtypeEnum,
        public readonly label: string,
    ) { }
}

export const EXPENSE_SUBTYPE_TABLE_LOOKUP: Record<CostTypeEnum, CostSubtypeEnum[]> = {
    [CostTypeEnum.TRAVEL]: [
        CostSubtypeEnum.DISPLACEMENT,
        CostSubtypeEnum.ACCOMMODATION_MEALS,
    ],
    [CostTypeEnum.PERSONNEL_MANAGEMENT_ADMINISTRATION]: [],
    [CostTypeEnum.MAINTENANCE_ACTIVITIES]: [
        CostSubtypeEnum.RENT,
        CostSubtypeEnum.UTILITIES,
        CostSubtypeEnum.UTILITIES_CONSTRUCTION_AND_EQUIPMENT,
        CostSubtypeEnum.INSURANCE,
        CostSubtypeEnum.CONSUMABLES,
        CostSubtypeEnum.MATERIALS_FOR_ACTIVITIES,
        CostSubtypeEnum.TRANSPORT_OF_GOODS_AND_INMOVILITIES,
        CostSubtypeEnum.OCCASIONAL_COLLABORATIONS,
        CostSubtypeEnum.CONFERENCES_LECTURES,
        CostSubtypeEnum.WORK_OTHER_COMPANIES,
        CostSubtypeEnum.VOLUNTEERING,
        CostSubtypeEnum.LIABILITY_INSURANCE,
        CostSubtypeEnum.EXPENSES_INCURRED_BENEFICIARIES,
        CostSubtypeEnum.SOFTWARE_LICENSES,
        CostSubtypeEnum.OTHERS_MINOR_EXPENSES
    ],
    [CostTypeEnum.INVESTMENT]: [
        CostSubtypeEnum.FURNITURE,
        CostSubtypeEnum.COMPUTER_EQUIPMENT,
        CostSubtypeEnum.REAL_ESTATE,
        CostSubtypeEnum.OTHERS_INVESTMENT_EXPENSES
    ],
    [CostTypeEnum.MANAGEMENT_ADMINISTRATION]: [
        CostSubtypeEnum.CONSULTING_SERVICES,
        CostSubtypeEnum.AUDITING,
        CostSubtypeEnum.LABOR_MANAGEMENT_LICENSES,
        CostSubtypeEnum.QUALITY,
        CostSubtypeEnum.PERSONNEL
    ],
    [CostTypeEnum.OTHER_SUBSIDIZABLE_EXPENSES]: [],
};